import './index.scss'
$("#nav7").addClass("active");
$(".nei-nav").click(function () {
    if($(".nei-nav li").eq(1).hasClass("active")) {
        $(".nei-nav").addClass("white");
    }else {
        $(".nei-nav").removeClass("white");
    }
})

$(".section3 ul li").click(function () {
    if($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).find(".content").slideUp();
    }else {
    $(".section3 ul li").removeClass("active");
    $(".section3 ul li .content").slideUp();
    $(this).addClass("active");
    $(this).find(".content").slideDown();
    }
})